export default {
    English: 'images/logo-en.png',
    Spanish: 'images/logo-es@2x.png',
};
